<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-input ttLabel="stockbatch_keyno" [ttModel]="setting.stockbatch_keyno" [ttButtons]="stockBatchButtons" ttReadonly></tt-input>
        <tt-input ttLabel="suppliers_batchno" [ttModel]="setting.suppliers_batchno" ttReadonly></tt-input>
        <tt-input ttLabel="prod_id" [ttModel]="setting.prod_id" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="setting.prod_name" ttReadonly></tt-input>
        <tt-input-number ttLabel="quantity" [ttModel]="setting.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="quantity_stock" [ttModel]="setting.quantity_stock" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>

        <tt-tabs [(ttSelectedId)]="setting.gb_tracesb_main" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="B" ttLabel="gb_tracesb_main_backward"></tt-tab>
            <tt-tab ttId="F" ttLabel="gb_tracesb_main_forward"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
